import {
    FETCH_SETTING
} from '../actions/types';

export const reducer = (state = {}, action) => {
    
    switch (action.type) {
        case FETCH_SETTING:
            return { ...state, pageSetting: action.payload }
        default:
            return state;
    }
};
